import Vue from 'vue';
import Router from 'vue-router';
import ItemList from '@/components/ItemList';
import Admin from '@/components/Admin';
import Login from '@/components/Login';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ItemList',
      component: ItemList,
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      beforeEnter: (to, from, next) => {
        setTimeout(() => {
          if (!EventBus.user) {
            return next('/login');
          }
          return next();
        }, 100);
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        setTimeout(() => {
          if (EventBus.user) {
            return next('/admin');
          }
          return next();
        }, 100);
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js